import React from 'react';
import Modal from '../../Components/Modal';
import CopyableValue from '../../Components/Formatting/CopyableValue';
import { useShortenUrls } from '../../Data/ShortLinks';

const Links = ({document, isOpen, setIsOpen}) => {
    return <Modal title="Document Links" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner document={document} />}
    </Modal>
}

const Inner = ({document}) => {
    const {shortUrls} = useShortenUrls({
        doc: document.downloadUrl,
    });
    return <>
        <div class="prose text-muted mb-3">
            <p>You can share these links with people who need to download your {document.title} document.</p>
        </div>
        <CopyableValue title="Direct link" value={document.downloadUrl} className="mb-3" />
        <CopyableValue title="Short link" value={(shortUrls && shortUrls?.doc) ?? ' '} />
    </>
}

export default Links;